import React from 'react';
import { GlassSidePanel } from '@/components/admin/redesign';

interface DesktopSidePanelProps {
  visible: boolean;
  onClose: () => void;
  width?: number;
  children: React.ReactNode;
  showOverlay?: boolean;
  closeOnOverlayPress?: boolean;
  /** Glass strength. Use 'strong' when the panel stacks over another glass surface (data tables, chat windows). */
  variant?: 'soft' | 'strong';
}

/**
 * Theme-aware desktop side panel — delegates to the shared `GlassSidePanel`
 * primitive so all admin edit flows pick up the glass treatment automatically.
 * Preserves the original prop API for back-compat with existing call sites.
 */
export const DesktopSidePanel: React.FC<DesktopSidePanelProps> = ({
  visible,
  onClose,
  width = 480,
  children,
  showOverlay = true,
  closeOnOverlayPress = true,
  variant = 'strong',
}) => {
  return (
    <GlassSidePanel
      visible={visible}
      onClose={onClose}
      width={width}
      showOverlay={showOverlay}
      closeOnOverlayPress={closeOnOverlayPress}
      side="right"
      variant={variant}
    >
      {children}
    </GlassSidePanel>
  );
};
